export default function FormattedDate(props) {
  function checkTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
  //set date
  function setDate(timestamp) {
    let month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let now = new Date(timestamp);
    //create Data using Time of data calculation, unix, UTC
    //special type for Date

    //reffers to array of days an
    let currentDate = now.getDate();
    let currentMonth = month[now.getMonth()];
    let currentHours = now.getHours();
    let currentMinutes = now.getMinutes();
    currentHours = checkTime(currentHours);
    //call function to add 0 if it is needed
    currentMinutes = checkTime(currentMinutes);

    return `${currentDate} ${currentMonth} ${currentHours}:${currentMinutes}`;
  }

  return setDate(props.timestamp);
}
